let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([require("./helpers/browser/css-loader")(require('./helpers/bundle-manifest').resolve("27hfY")), load("deUOc")]).then(() => parcelRequire('7g6vL'));